import * as React from 'react';
import RenderingService from 'services/RenderingService';
const RenderingContext = React.createContext(new RenderingService({ dateFormat: 'normal', booleanFormat: 'x' }));
export default RenderingContext;
